const createTagFields = size => {
  const tagFileds = [];
  for (let i = 1; i <= size; i++) {
    tagFileds.push({
      field: `Tag ${i}`,
      type: 'string',
      description: 'Key:Value pairs to help organize users.',
      dbFieldName: `tag${i}`,
      required: false,
      example: 'County:Jefferson',
    });
  }
  return tagFileds;
};

const createCustomFields = size => {
  const customFields = [];
  for (let i = 1; i <= size; i++) {
    customFields.push({
      field: `Custom Field ${i}`,
      type: 'string',
      description: 'FieldName:Value',
      dbFieldName: `customField${i}`,
      required: false,
      example: 'FieldName:Value',
    });
  }
  return customFields;
};

export default {
  sites: [
    {
      field: 'Site Name',
      type: 'string',
      description: 'A friendly name for the site.',
      dbFieldName: 'name',
      required: true,
      example: 'RingCentral HQ',
    },
    {
      field: 'Address 1',
      type: 'string',
      description: 'Address of the site.',
      dbFieldName: 'street_address',
      required: true,
      example: '123 St, Suite 200',
    },
    {
      field: 'Address 2',
      type: 'string',
      description: 'Address line 2 of the site.',
      dbFieldName: 'street_address_2',
      required: false,
      example: '123 St, Suite 200',
    },
    {
      field: 'City',
      type: 'string',
      description: 'The city the site is located in.',
      dbFieldName: 'city',
      required: true,
      example: 'Belmont',
    },
    {
      field: 'State',
      type: 'string',
      description: 'The state the site is located in.',
      dbFieldName: 'state',
      required: false,
      example: 'California',
      isDropdown: true,
    },
    {
      field: 'Postal Code',
      type: 'string',
      description: 'The postal code (or ZIP) for the site.',
      dbFieldName: 'postal_code',
      required: true,
      example: '94002',
    },
    {
      field: 'Country',
      type: 'string',
      description: 'The country the site is located in.',
      dbFieldName: 'country',
      required: true,
      example: 'United States',
      isDropdown: true,
    },
    {
      field: 'Device Due Date',
      type: 'date',
      description: 'The due date for this site to be complete.',
      dbFieldName: 'due_date',
      required: false,
      example: 'YYYY-MM-DD',
    },
  ],
  profiles: [
    {
      field: 'Site Name',
      type: 'string',
      description: 'A friendly name for the site.',
      dbFieldName: 'site_name',
      required: true,
      example: 'RingCentral HQ',
    },
    // {
    //   field: 'Cost Center',
    //   type: 'string',
    //   description: 'The cost center for the site.',
    //   dbFieldName: 'cost_center',
    //   example: 'Sales',
    // },
    {
      field: 'Pro Services Onsite',
      type: 'boolean',
      description:
        'Do you want RingCentral Pro Services on-site to help with deployment? Y or N options.',
      dbFieldName: 'pro_services_onsite',
      example: 'Y',
      isDropdown: true,
    },
    {
      field: 'Disconnect Existing Equipment',
      type: 'boolean',
      description:
        'Does RingCentral Pro Services need to disconnect any existing on premise equipment? - Y or N options.',
      dbFieldName: 'disconnect_existing_equipment',
      example: 'Y',
      isDropdown: true,
    },
    {
      field: 'PoE',
      type: 'boolean',
      description: 'Will devices at this site be using PoE? - Y or N options.',
      dbFieldName: 'poe',
      example: 'Y',
      isDropdown: true,
    },
    {
      field: 'Device Port Type',
      type: 'enum',
      description:
        'The Ethernet port type for the devices at this site. Dedicated, Pass-Through, or Both.',
      dbFieldName: 'device_port_type',
      example: 'Both',
    },
    // {
    //   field: 'Additional Site Details',
    //   type: 'string',
    //   description: 'Any additional notes about the site.',
    //   dbFieldName: 'additional_site_details',
    //   example: 'We have three door buzzers',
    // },
    {
      field: 'Go Live Target Date',
      type: 'date',
      description: 'The projected Go-Live target date for this site.',
      dbFieldName: 'go_live_target_date',
      example: 'YYYY-MM-DD',
    },
    // {
    //   field: 'Date To Send Welcome Email',
    //   type: 'date',
    //   description: 'Date to send the welcome email to all users of this site.',
    //   dbFieldName: 'date_to_send_welcome_email',
    //   example: 'YYYY-MM-DD',
    // },
    // {
    //   field: 'Send welcome emails immediately on sync?',
    //   type: 'boolean',
    //   description:
    //     'This option will override the date and send welcome emails to user created in Conductor once you sync a workspace.',
    //   dbFieldName: 'send_welcome_email',
    //   example: 'Y',
    // },
    {
      field: 'Site Code',
      type: 'integer',
      description:
        'The site code for the site. Must not exceed site codes format for the account.',
      dbFieldName: 'site_code',
      required: false,
      example: '111',
    },
    {
      field: 'Main Extension Number',
      type: 'integer',
      description:
        'The main extension number for the site. Must be between 1-99999999 and cannot exceed extension format for the account.',
      dbFieldName: 'main_extension_number',
      required: false,
      example: '5568',
    },
    {
      field: 'Timezone',
      type: 'string',
      description: 'The timezone the site is located in.',
      dbFieldName: 'timezone',
      required: false,
      example: 'US/Mountain',
      isDropdown: true,
    },
    {
      field: 'Overhead Paging',
      type: 'boolean',
      description: 'Does this site require overhead paging? Y or N.',
      dbFieldName: 'overhead_paging',
      example: 'Y',
      isDropdown: true,
    },
    {
      field: 'Paging Hardware Manufacturer',
      type: 'string',
      description: 'The paging hardware manufacturer for this site.',
      dbFieldName: 'paging_hardware_manufacturer',
      example: 'Cyberdata',
    },
    {
      field: 'Description of Paging Zones',
      type: 'string',
      description: 'Description of paging zones for this site.',
      dbFieldName: 'paging_hardware_description',
      example: 'How many zones, nightringer, etc...',
    },
    {
      field: 'Main Number',
      type: 'string',
      description:
        'The main E.164 formatted phone number(s) for this site. Use a comma to separate multiple numbers.',
      dbFieldName: 'main_number',
      example: '+130355555555',
    },
    {
      field: 'Fax Type',
      type: 'string',
      description:
        'The faxing type for this site. Options are Disabled, E-Fax, ATA+Fax Machine or POTS Line(outside RC). Use a comma to separate multiple fax types.',
      dbFieldName: 'faxing',
      example: 'Disabled',
    },
    // {
    //   field: 'Paging Hardware',
    //   type: 'string',
    //   description:
    //     "A description of the site's paging hardware, if applicable.",
    //   dbFieldName: 'paging_hardware',
    //   example: 'amp, server, etc.',
    // },
    {
      field: 'Door Buzzer Integration',
      type: 'boolean',
      description: 'Does this site  require a door buzzer integration? Y or N.',
      dbFieldName: 'door_buzzer_integration',
      example: 'Y',
      isDropdown: true,
    },
    {
      field: 'Outbound Cnam',
      type: 'string',
      description:
        "The Outbound CNAM (Caller-ID Name) string to be used for this site's configuration",
      dbFieldName: 'outbound_cnam',
      example: 'RINGCENTRAL INC',
    },
    {
      field: 'User Language',
      type: 'string',
      description: 'The default language for the account and notifications.',
      dbFieldName: 'user_language',
      required: false,
      example: 'English (United States)',
      isDropdown: true,
    },
    {
      field: 'Greeting Language',
      type: 'string',
      description: 'The language to be used for phone greetings.',
      dbFieldName: 'greeting_language',
      required: false,
      example: 'English (United States)',
      isDropdown: true,
    },
    {
      field: 'Regional Format',
      type: 'string',
      description:
        'Choose the format to show date, time, currency and other numbers.',
      dbFieldName: 'regional_format',
      required: false,
      example: 'English (United States)',
      isDropdown: true,
    },
    {
      field: 'Time Format',
      type: 'string',
      description: 'Choose between 24hr or 12hr time formats.',
      dbFieldName: 'time_format',
      required: false,
      example: '12h',
    },
  ],
  siteUsers: [
    {
      field: 'Site Name',
      type: 'string',
      description: 'A friendly name for the site.',
      dbFieldName: 'site_name',
      required: true,
      example: 'RingCentral HQ',
    },
    {
      field: 'First Name',
      type: 'string',
      description: 'First name of the user.',
      dbFieldName: 'first_name',
      required: true,
      example: 'John',
    },
    {
      field: 'Last Name',
      type: 'string',
      description: 'Last name of the user.',
      dbFieldName: 'last_name',
      required: true,
      example: 'Doe',
    },
    {
      field: 'Email',
      type: 'string',
      description: 'The email address of the user',
      dbFieldName: 'email',
      required: true,
      example: 'test@example.org',
    },
    {
      field: 'User Type',
      type: 'string',
      description:
        'The type of extension. Options are User or Limited Extension or Announcement Only or Message Only or Virtual User.',
      dbFieldName: 'user_type',
      required: true,
      example:
        'User, VirtualUser, LimitedExtension, Announcement Only, Message Only',
      isDropdown: true,
    },
    {
      field: 'Extension',
      type: 'integer',
      description:
        'The extension number for the user. Must be between 1-99999999 and cannot exceed extension format for the account.',
      dbFieldName: 'extension',
      required: true,
      example: '101',
    },
    {
      field: 'Phone Number',
      type: 'string',
      description:
        'The E.164 formatted phone number(s) for this user. You can assign up to 4 phone numbers to one user.',
      dbFieldName: 'phone',
      required: false,
      example: '+13035555555',
    },
    {
      field: 'Address 1',
      type: 'string',
      description: 'Address of the user.',
      dbFieldName: 'street_address',
      required: false,
      example: '123 St, Suite 200',
    },
    {
      field: 'Address 2',
      type: 'string',
      description: 'Address line 2 of the user.',
      dbFieldName: 'street_address_2',
      required: false,
      example: '123 St, Suite 200',
    },
    {
      field: 'City',
      type: 'string',
      description: 'The city the user is located in.',
      dbFieldName: 'city',
      required: false,
      example: 'Belmont',
    },
    {
      field: 'State',
      type: 'string',
      description: 'The state the user is located in.',
      dbFieldName: 'state',
      required: false,
      example: 'California',
      isDropdown: true,
    },
    {
      field: 'Postal Code',
      type: 'string',
      description: 'The postal code (or ZIP) for the user.',
      dbFieldName: 'postal_code',
      required: false,
      example: '94002',
    },
    {
      field: 'Country',
      type: 'string',
      description: 'The country the user is located in.',
      dbFieldName: 'country',
      required: false,
      example: 'United States',
      isDropdown: true,
    },
    {
      field: 'Preference for extension location',
      type: 'string',
      description:
        'Preference for extension location for the user. Options are None or Use unassigned extension matching selected country, or Use unassigned extension from a different country.',
      dbFieldName: 'rcextension_location_check',
      required: false,
      example:
        'None, Use unassigned extension matching selected country, Use unassigned extension from a different country.',
      isDropdown: true,
    },
    {
      field: 'Country Code',
      type: 'string',
      description: 'The Country code code for the user.',
      dbFieldName: 'rcextension_location_country',
      required: false,
      example: 'United States, USA',
      isDropdown: true,
    },
    {
      field: 'Desired Area Code',
      type: 'number',
      description: 'The Desired area code for the user.',
      dbFieldName: 'rcextension_location_area_code',
      required: false,
      example: '594700',
    },
    // {
    //   field: 'Temp #',
    //   type: 'string',
    //   description: 'Temporary phone number.',
    //   dbFieldName: 'temporary_phone',
    //   required: false,
    //   example: '+14444444005',
    // },
    {
      field: 'Dept',
      type: 'string',
      description: 'The department/organization for the user.',
      dbFieldName: 'dept',
      required: false,
      example: 'Marketing',
    },
    // {
    //   field: 'Cost center',
    //   type: 'string',
    //   description: 'The cost center for the site.',
    //   dbFieldName: 'cost_center',
    //   required: false,
    //   example: 'costcenter1',
    // },
    {
      field: 'Setup Wizard Status',
      type: 'string',
      description:
        'The state of the user setup wizard. Options are Not Started or Completed.',
      dbFieldName: 'setup_wizard_status',
      required: false,
      example: 'Completed',
    },
    {
      field: 'Password',
      type: 'string',
      description:
        'Required if SSO is disabled and the setup wizard state is set to complete for this user. 8-32 characters in length, must be mix of numbers and letters containing at least one special character or uppercase letter.',
      dbFieldName: 'password',
      required: false,
      example: 'sLqH6Mo7zNIpr2I3',
    },
    {
      field: 'Pin',
      type: 'number',
      description:
        'Required if setup wizard is set to completed. - Must be between 6 and 10 digits in length. Cannot contain repeating or sequential digits.',
      dbFieldName: 'pin',
      required: false,
      example: '104784',
    },
    {
      field: 'Secret Question',
      type: 'string',
      description: 'Secret question for security.',
      dbFieldName: 'secret_question',
      required: false,
      example: 'Secret question?',
    },
    {
      field: 'Secret Question answer',
      type: 'string',
      description: 'Answer to secret question.',
      dbFieldName: 'secret_question_answer',
      required: false,
      example: 'Answer of secret question.',
    },
    // {
    //   field: 'Template',
    //   type: 'string',
    //   description:
    //     'The name of template for the user. Must already be present in the account.',
    //   dbFieldName: 'template',
    //   required: false,
    //   example: 'Branch Office User Template',
    //   isDropdown: true,
    // },
    {
      field: 'Role',
      type: 'string',
      description:
        'The name of the role for the user. Only built-in platform roles are supported.',
      dbFieldName: 'role',
      required: false,
      example: 'Standard',
      isDropdown: true,
    },
    ...createTagFields(20),
    ...createCustomFields(5),
  ],
  devices: [
    {
      field: 'Email',
      type: 'string',
      description:
        'The email address of the user to which this device will belong.',
      dbFieldName: 'email',
      required: true,
      example: 'test@example.org',
    },
    {
      field: 'Device Type',
      type: 'string',
      description:
        'The type of device for this user. Options are Softphone, New Device, or Existing Device.',
      dbFieldName: 'device_type',
      required: true,
      example: 'New Device',
      isDropdown: true,
    },
    {
      field: 'Device Model',
      type: 'string',
      description:
        'The model of the device for the user if New Device or Existing Device are selected.',
      dbFieldName: 'device_model',
      required: false,
      example: 'Polycom VVX450 Business IP Phone',
      isDropdown: true,
    },
    {
      field: 'MAC Address',
      type: 'string',
      description:
        'The MAC address of the device. Required if Existing Device is selected. Supported formats are aa:bb:cc:dd:ee:ff and aabbccddeeff.',
      dbFieldName: 'mac_address',
      required: false,
      example: '12:b1:45:7e:8d:10 or 12b1457e8d10',
    },
  ],
  numbers: [
    {
      field: 'Phone Number',
      type: 'string',
      description: 'Phone number in E164. format.',
      dbFieldName: 'phoneNumber',
      required: true,
      example: '+17162741616',
    },
  ],
  //   callHandling: [
  //     {
  //       field: 'Site Name',
  //       type: 'string',
  //       description: 'A friendly name for the site.',
  //       dbFieldName: 'site_name',
  //       required: true,
  //       example: 'RingCentral HQ',
  //     },
  //     {
  //       field: 'Name',
  //       type: 'string',
  //       description: 'A friendly name for the item.',
  //       dbFieldName: 'name',
  //       required: true,
  //       example: 'Support Queue',
  //     },
  //     {
  //       field: 'Type',
  //       type: 'string',
  //       description: 'The item type. Options are IVR or Call Queue.',
  //       dbFieldName: 'type',
  //       required: true,
  //       example: 'Call Queue',
  //     },
  //     {
  //       field: 'Phone Number',
  //       type: 'string',
  //       description: 'The E.164 formatted phone number for this item.',
  //       dbFieldName: 'phone',
  //       example: '+13035555555',
  //     },
  //     {
  //       field: 'Extension',
  //       type: 'integer',
  //       description:
  //         'The extension number for this item. Must be between 1-99999999 and cannot exceed extension format for the account.',
  //       dbFieldName: 'extension',
  //       required: true,
  //       example: '101',
  //     },
  //     {
  //       field: 'Temp Number',
  //       type: 'string',
  //       description: 'The E.164 formatted temporary phone number for this item.',
  //       dbFieldName: 'temporary_phone',
  //       required: false,
  //       example: '+13035555555',
  //     },
  //   ],
};
